import React, { FunctionComponent } from "react";
import "./style.scss";

const TermsPage: FunctionComponent = () => {
    return <div className="TermsPage">
        <div className="content">
            <h1>Terms And Conditions</h1>
            <div className="date">Effective Date: December 30, 2022</div>
                <div className="blocks">

                    <div className="block">
                        <h3>Definitions</h3>
                        <div className="text">
                            <b>Employer</b> - Timinator’s tenant<br/>
                            <b>Employee</b> - Timininator tenant’s employee<br/>
                            <b>Client</b> - Timininator tenant’s client<br/>
                            <b>User</b> - Any Timininator’s tenant’s employee, added as a user of the service for the tenant<br/>
                            <b>Application</b> - Bot application for time tracking<br/>
                            <b>Service</b> - Electronic time tracking service offered by Spark Agency FZE to its users.
                            <br/><br/>
                            In these terms and conditions, the terms 'We,' 'Our,' 'Ours,' and 'Us,' refer collectively to Spark
                            Agency FZE, and the terms 'You' and 'Your' refer to you, the person accepting these terms and
                            conditions. The terms 'Party' and 'Parties' refer to both Spark Agency FZE and yourself, or either
                            Spark Agency FZE or yourself, as the context requires.
                        </div>
                    </div>

                    <div className="block">
                        <h3>General</h3>
                        <div className="text">
                            By accessing or using our time tracking bot application, you agree to be bound by these terms
                            and conditions and our privacy policy. If you do not agree to these terms and conditions or our
                            privacy policy, you must not access or use the application.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Service Description</h3>
                        <div className="text">
                            Our time-tracking bot application allows users to track and record the time they spend on tasks,
                            projects, and activities. By inputting tasks and setting up notifications or recurring shifts, users
                            can accurately track their work hours. The time-tracking bot is intended to assist users in
                            tracking and managing their time and is not responsible for any errors or discrepancies in the
                            recorded data.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Use of Service</h3>
                        <div className="text">
                            We grant you a non-sublicensable, non-transferable, non-exclusive, limited license to access
                            and use our service, including the relevant code version of our software, solely as necessary to
                            use the service and in accordance with these terms. All rights not expressly granted by this
                            license are retained by us.
                            <br/><br/>
                            You must ensure that all users of the service are over 16 years old and comply with these terms.
                            You are solely responsible for the way you and your users use the service and any client data
                            stored or processed through them.
                            <br/><br/>
                            You agree to use the service only as intended and permitted by their normal functionality and
                            these terms, and not to alter or modify any part of the service.
                            <br/><br/>
                            You must also comply with all applicable laws and regulations, including export and control laws
                            and regulations, and not use the service in a way that suggests that we endorse or promote you
                            or any third party. You may not use the service to solicit illegal activities or infringe on the rights
                            of us or others.
                            <br/><br/>
                            You may not access or use the service through any means other than the interface and
                            instructions we provide or use any automatic or manual process to reproduce or circumvent the
                            navigational structure or presentation of the service.
                            <br/><br/>
                            You may not probe, scan, or test the vulnerability of the services or any network connected to
                            them, or breach their security or authentication measures.
                            <br/><br/>
                            You may not reverse look-up, trace, or seek to trace any information on any other customer of
                            ours or exploit the services or any information made available through them for any
                            unauthorized purpose.
                            <br/><br/>
                            You may not use the service in a way that distracts you and prevents you from obeying traffic or
                            safety laws or in a way that suggests that we endorse or promote any third-party causes, ideas,
                            products, sites, applications, platforms, or services.
                            <br/><br/>
                            You may not attempt to gain unauthorized access to any portion of the application or to any
                            other computer or network connected to the application, by hacking, password mining, or any
                            other means. You may not use the application to transmit any viruses, worms, or other malicious
                            software, or to engage in any spamming or phishing activities.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Responsibilities</h3>
                        <div className="text">
                            As the operator of the time-tracking bot application, we have the following responsibilities:
                            <ul>
                                <li>To provide the application to you on a continuous basis, subject to any scheduled downtime for maintenance or updates</li>
                                <li>To maintain the security and confidentiality of your account and password, and to prevent unauthorized access to or use of the application</li>
                                <li>To promptly address any issues or problems that you may encounter while using the application</li>
                                <li>To comply with all applicable laws and regulations in connection with the operation of the application.</li>
                            </ul>
                            We will use reasonable efforts to maintain the availability and functionality of the application, but
                            we do not guarantee that the application will be error-free or that it will always be available.
                            <br/><br/>
                            We will not be liable to you or any third party for any damages or losses resulting from any
                            downtime or unavailability of the application, or from any errors or omissions in the content or
                            functionality of the application.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Subscription</h3>
                        <div className="text">
                            Our time-tracking bot application is offered on a subscription basis, with fees charged on a
                            monthly basis. We currently offer a free trial period of one month for new users. After the free
                            trial period, users who have added a payment method to their account will be automatically
                            charged the subscription fee. If payment fails, we reserve the right to stop the service until
                            payment is successfully processed.
                            <br/><br/>
                            Users who have not added a payment method will receive notifications from our time-tracking
                            bot application reminding them to do so in order to continue using the service. We reserve the
                            right to change the subscription fee at any time, with at least 30 days' notice to users via email
                            to the email addresses associated with their accounts.
                            <br/><br/>
                            Any changes to the subscription fee will take effect at the start of the next billing period. Users
                            can cancel their subscriptions at any time by following the cancellation instructions in their
                            account settings or by contacting our support team.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Refunds</h3>
                        <div className="text">
                            Before making a purchase, users are responsible for understanding the features and limitations
                            of the application. We will not issue refunds for any reason other than those required by law.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Limitation of Liability</h3>
                        <div className="text">
                            We will not be liable for any damages or losses resulting from the use of our time-tracking bot
                            application, including but not limited to direct, indirect, consequential, incidental, special, or
                            punitive damages. This includes damages or losses caused by errors or omissions in the
                            application, or by any unauthorized access to or alteration of user transmissions or data.
                            <br/><br/>
                            In addition, we will not be liable for any damages or losses resulting from the interruption or
                            termination of the application, or from any failure to provide the application. We reserve the right
                            to modify or discontinue the application at any time, with or without notice.
                            <br/><br/>
                            This limitation of liability applies to the fullest extent permitted by law and will survive the
                            termination of these terms and conditions or the use of the application.
                            <br/><br/>
                            Users agree to indemnify and hold us harmless from any claims, damages, or expenses arising
                            from their use of the application or violation of these terms and conditions.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Disclaimer</h3>
                        <div className="text">
                            The information provided and generated by our time-tracking bot application is for general
                            informational purposes only and is not intended as legal, financial, or professional advice. We
                            do not guarantee the accuracy, completeness, or usefulness of this information, and we will not
                            be liable for any reliance on this information. Users are responsible for verifying the accuracy of
                            the information provided by the application, and their recorded data and using it at their own
                            risk.
                            <br/><br/>
                            We are not responsible for the content of any third-party websites or resources that may be
                            linked to or from the application. The inclusion of any link does not imply endorsement by us of
                            the website or resource. We have no control over the content of these websites or resources,
                            and we will not be liable for any damages or losses resulting from the use of these websites or
                            resources.
                            <br/><br/>
                            The application is provided on an "as is" basis, without warranties of any kind. We make no
                            representations or warranties of any kind, express or implied, about the completeness,
                            accuracy, reliability, suitability, or availability with respect to the application or the information,
                            products, services, or related graphics contained in the application for any purpose. Any
                            reliance you place on such information is therefore strictly at your own risk.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Termination</h3>
                        <div className="text">
                            We reserve the right to terminate your access to our time tracking bot application at any time
                            and without notice, for any reason or no reason. This includes the right to terminate your access
                            if you violate these terms and conditions or engage in any conduct that we deem inappropriate
                            or harmful to the operation of the application or to other users.
                            <br/><br/>
                            Upon termination of your access, you will no longer be able to use the application and we may
                            delete any information or data associated with your account. We will not be liable to you or any
                            third party for any damages or losses resulting from the termination of your access to the
                            application.
                            <br/><br/>
                            If you wish to terminate your access to the application, you may do so at any time by following
                            the cancellation instructions in your account settings or by contacting our support team.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Changes</h3>
                        <div className="text">
                            We reserve the right to unilaterally modify these terms and conditions at any time and without
                            notice, for any reason or no reason. Any changes to these terms and conditions will be effective
                            immediately upon posting on the application or upon notification to you by email. Your continued
                            use of the application after any changes are made will constitute your acceptance of the revised
                            terms and conditions.
                            <br/><br/>
                            It is your responsibility to check these terms and conditions periodically for any changes. If you
                            do not agree to the revised terms and conditions, you must stop using the application.
                            <br/><br/>
                            The relevant version of the terms and conditions can be always found at:<br/>
                            <a href="https://timinator.app/termsAndConditions">https://timinator.app/termsAndConditions</a>.
                            <br/><br/>
                            We also reserve the right to modify the features, functionality, and content of the application at
                            any time and without notice. We will not be liable to you or any third party for any damages or
                            losses resulting from any such changes.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Intellectual property rights</h3>
                        <div className="text">
                            The content of our time-tracking bot application, including but not limited to text, graphics, logos,
                            images, and software, is the property of Spark Agency FZE or its licensors and is protected by
                            intellectual property laws. Any use of the content of the application, including reproduction,
                            modification, distribution, or re-publication, without the prior written consent of Spark Agency
                            FZE, is strictly prohibited.
                            <br/><br/>
                            You may not use any content from the application for commercial purposes without the express
                            written consent of Spark Agency FZE. You may not use any data mining, robots, or similar data
                            gathering or extraction tools to access, extract, or collect information from the application,
                            without the prior written consent of Spark Agency FZE.
                            <br/><br/>
                            You may not use any trademark, service mark, or logo displayed on the application without the
                            prior written consent of Spark Agency FZE or the owner of the trademark, service mark, or logo.
                            Any unauthorized use of the content or materials on the application may violate copyright,
                            trademark, and other intellectual property laws and could result in criminal or civil penalties.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Privacy policy</h3>
                        <div className="text">
                            Our time-tracking bot application collects and processes personal data in accordance with our
                            privacy policy. By using the application, you agree to the collection, use, and disclosure of your
                            personal data in accordance with our privacy policy. You can find our privacy policy at <a href="https://timinator.app/privacyPolicy">https://timinator.app/privacyPolicy</a>. We encourage you to review our privacy policy to understand
                            how we collect, use, and protect your personal data. 
                        </div>
                    </div>

                    <div className="block">
                        <h3>Users Content</h3>
                        <div className="text">
                            Our time-tracking bot application allows users to create, upload, and share content, including
                            but not limited to employers employees, and clients' information, projects’ details, and tracked
                            working hours. By creating, uploading, or sharing content on the application, you represent and
                            warrant that you have the right to do so and that the content does not infringe the intellectual
                            property rights of any third party.
                            <br/><br/>
                            You grant us a non-exclusive, worldwide, perpetual, irrevocable, royalty-free, sublicensable,
                            transferable license to use, reproduce, modify, adapt, publish, translate, create derivative works
                            from, distribute, and display the content for any purpose, including but not limited to generating
                            reports and analytics.
                            <br/><br/>
                            We reserve the right to remove or edit any content that we determine, in our sole discretion, to
                            be inappropriate or in violation of these terms and conditions. We will not be liable to you or any
                            third party for any damages or losses resulting from the removal or editing of any content.
                            <br/><br/>
                            You are solely responsible for the content that you create, upload, or share on the application,
                            and you agree to indemnify and hold us harmless from any claims, damages, or expenses
                            arising from your content or the use of your content by us or any third party.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Governing Law</h3>
                        <div className="text">
                            The governing law of this contract is the law of the European Union. The parties agree to try to
                            resolve any disputes arising under or in connection with this contract amicably through
                            negotiations. If the parties are unable to resolve a dispute through negotiations, they may seek
                            resolution through arbitration or through the courts, as appropriate.
                        </div>
                    </div>

                    <div className="block">
                        <h3>Contacts</h3>
                        <div className="text">
                            If you have any questions or concerns about our terms and conditions or the processing of your
                            personal data, please contact us at:
                            <br/><br/>
                            <a href="mailto:hello@timinator.app">hello@timinator.app</a><br/>
                            for general questions about the services we provide.
                            <br/><br/>
                            <a href="mailto:support@timinator.app">support@timinator.app</a><br/>
                            questions or concerns regarding the use of our service, billing, technical issues, and other
                            related matters.
                        </div>
                    </div>

            </div>
        </div>
    </div>
}

export default TermsPage;